<template>
  <div class="container">
    <div class="title">
      <a href="javascript:void(0);" class="back_btn" @click.prevent="closePage()">
        <img src="@/assets/images/close.svg" />
      </a>
      <span>Privacy Policy</span>
      <img src="@/assets/images/logo_header.png" alt="Logo" class="logo" />
    </div>
    <div class="content">
      <p class="date">Effective Date: 02/19/2026</p>
      <p>
        This Privacy Policy describes, in a comprehensive manner, how JoyJobs collects, uses, and disclose your data
        when you access or use our website and services.
      </p>
      <p>
        All references to Job Seeker, Employer, and Personal Data are defined as provided for in our Terms of Service.
      </p>
      <a-divider class="content_divider" />
      <p class="sub_title">1. The Scope of JoyJobs'Privacy Policy?</p>
      <p>
        This Privacy Policy covers data that we collect through the JoyJobs'website, directly from data subjects, or
        that we may obtain from third parties. In cases where you follow a link to a third-party website, you are no
        longer covered by our Privacy Policy.
      </p>
      <p>
        Under our Terms, JoyJobs'website is generally only for use by people aged 16 or over. However, if you are under
        the age of majority, you must use the JoyJobs'website under the supervision of your parent, legal guardian, or
        responsible adult even if your age is above the JoyJobs'permitted use age.
      </p>
      <a-divider class="content_divider" />
      <p class="sub_title">2. What Data We Collect?</p>
      <p>
        JoyJobs uses different types of information in order to provide our services to you. The Personal Data we
        collect and process may vary, depending on how you use our website. In detail, we collect the below three
        categories of data:
      </p>
      <ul class="content_ul">
        <li>
          Information You Provide<br />
          (1) Basic Account Information <br />
          (2) Profile Details <br />
          (3) Employers Information<br />
          (4) Accommodation Needs (Optional):<br />
          (5) Job Preferences <br />
          (6) Uploaded Documents
        </li>
        <li>
          Information We Collect Automatically <br />
          (1) Device & Session Data <br />
          (2) Behavioral Data <br />
          (3) In-App Communication Logs
        </li>
        <li>
          Cookies and Tracking Technologies <br />
          You may learn more by and through our Cookies Policy.
        </li>
      </ul>
      <a-divider class="content_divider" />
      <p class="sub_title">3. How We Retain and Use of Your Information?</p>
      <p>
        After collection of your Personal Data, JoyJobs retain such data until it is no longer necessary to fulfill the
        purpose it is being used for, as required by applicable laws, or until you ask us to delete it. Information on
        how long we retain your information, for each purpose, is set out in the following chat. In determining these
        appropriate retention periods, we consider the purposes for which we process Personal Data and whether we can
        achieve those purposes through other means. We also consider the extent, nature, and sensitivity of Personal
        Data and our legal obligations with respect to data.
      </p>

      <table class="content_table">
        <tbody>
          <tr>
            <td>Account management data</td>
            <td>
              Scope: including login credentials, permissions, and associated account actions;<br />
              Reason: to create and maintain an account at your direction;<br />
              Use: we collect, analyze, process, and store your account management data;<br />
              Basis: part of performance of a contract;<br />
              Retention Period: account lifetime, or per applicable legal requirements.
            </td>
          </tr>
          <tr>
            <td>Contact information</td>
            <td>
              Scope: name, telephone number, email and address (Identity documents may be collected in very limited
              circumstances, such as for appeals to account closures);<br />
              Reason: account creation and maintenance, communications between you and JoyJobs, or between Job Seekers
              and Employers;<br />
              Use: we collect, process and store your Contact Information;<br />
              Basis: part of performance of a contract, and our legitimate interest of improving our services;<br />
              Retention Period: account lifetime (copies of identity documents, if any, are deleted once identity has
              been verified).
            </td>
          </tr>
          <tr>
            <td>Profile date</td>
            <td>
              Scope: including your resume, photo (where applicable), preferences, and any other data included in your
              profile;<br />
              Reason: help Job Seekers finding more relevant job opportunities and enable Employers to locate
              candidates;<br />
              Use: we collect, store, process, and analyze your profile data;<br />
              Basis: performance of a contract and our legitimate interest for analytical purpose in providing a
              valuable and relevant service;<br />
              Retention Period: account lifetime, or you remove your profile data.
            </td>
          </tr>
          <tr>
            <td>
              Activity data &<br />
              Device information
            </td>
            <td>
              Scope: areas of the website you visit, where you click, scroll, hover over or otherwise interact with the
              website, when and for how long the activity occurred, IP address/device ID, user agent;<br />
              Reason: for safety and services improvement purposes;<br />
              Use: we collect, analyze, process, and store activity data may via automated means;<br />
              Basis: our legitimate interests in understanding how users interact with and use our website and keeping
              our website safe and secure;<br />
              Retention Period: account lifetime.
            </td>
          </tr>
          <tr>
            <td>Communication data</td>
            <td>
              Scope: interactions with or through JoyJobs, via messages or third-party messaging services, emails, etc.
              (please note that your relationship with third-party services is governed solely by your agreement with
              third-party operators of those platforms);<br />
              Reason: make it easier to apply to jobs for Job Seekers and to find candidates for Employers;<br />
              Use: we collect, analyze, process, profile, including via automated means, and store your Communication
              data;<br />
              Basis: our legitimate interests in providing a valid and relevant service to our users and to improve
              our<br />
              services;<br />
              Retention Period: account lifetime.
            </td>
          </tr>
        </tbody>
      </table>

      <p>
        Please note that JoyJobs may (1) retain any or all of the above-listed data for account under legal
        investigation proceeding as required by applicable law; or (2) where possible and replying on our legitimate
        interest in improving our website, anonymizes or aggregates Personal Data, so that it can no longer be
        associated with or identify a user, in which case JoyJobs can further process the information.
      </p>
      <a-divider class="content_divider" />
      <p class="sub_title">4. How and When We Share Your Information?</p>
      <ul class="content_ul">
        <li>To Employers</li>
        <li>
          By creating a profile through the JoyJobs website including when you upload your resume on the website, you
          are authorizing JoyJobs to make available your profile data to Employers, in accordance with our Terms.
        </li>
        <li>
          Job Seekers must opt out to deny Employers access to his or her accommodation needs, if any and provided in
          his or her profile.
        </li>
        <li>To Job Seekers</li>
        <li>
          When creating an account with JoyJobs, you agree that JoyJobs may make available your employment opening
          and/or contact information to Job Seekers according to our Terms.
        </li>
        <li>To General Website Visitors</li>
        <li>
          When users post content on the JoyJobs'website in a manner that is intended to make that content visible by
          general public, JoyJobs reserves the right to aggregate and share that information, including but may not
          limited to users'first name, profile photo, city where user located, with the general website visitors.
        </li>
        <li>To Third-Party Service Providers</li>
        <li>
          We perform automated processing of Personal Data to analyze and predict a user's preferences and interests. We
          use artificial intelligence in support of our goals to help people find jobs. We collect Personal Data for
          research purposes to improve our services and to enhance user experience. Either for performance of a contract
          or for our legitimate interest to provide qualified and valuable services, third-party service providers are
          involved during our practice described herein and are covered by appropriate data agreements for doing so.
        </li>
        <li>In Legal or Safety Situations</li>
        <li>
          We may disclose data when required by applicable law, legal proceedings, or protections of JoyJobs, our users,
          or relevant third-parties from damages and harms.
        </li>
      </ul>
      <a-divider class="content_divider" />
      <p class="sub_title">5. Your Personal Rights.</p>
      <ul class="content_ul">
        <li>The right to access and control.</li>
        <li>
          You have a right to know what Personal Data JoyJobs has about you and how it is processed. You have a right to
          obtain a copy of your Personal Date at any time during your account lifetime.
        </li>
        <li>The right to correct inaccuracies.</li>
        <li>
          You have the right to correct any inaccuracies in your Personal Data. You can modify much of your Personal
          Data by editing your account profile information directly.
        </li>
        <li>The right to delete.</li>
        <li>
          You have the right to delete your Personal Data via submitting a request to delete your data and close your
          account or deleting much of your Personal Data by removing it from your account directly.
        </li>
        <li>The right to opt out of the processing for purposes of sale and targeted advertising.</li>
        <li>
          You have the right to opt out of the processing of your personal data for purposes of the sale of your
          personal data. Your personal data is “sold” when provided to a third party for monetary or other valuable
          consideration. You have the right to opt out of the processing of your personal data for purposes of targeted
          advertising. To opt out, please send an email to hello@joylanders.com.
        </li>
        <li>The right to opt out of profiling in furtherance of a legal or similarly significant effect.</li>
        <li>
          You have the right to opt out of the processing of personal data for purposes of profiling in furtherance of a
          decision that produces a legal or similarly significant effect. To opt out, please send an email to
          hello@joylanders.com.
        </li>
        <li>The right to limit the use of your sensitive Personal Data.</li>
        <li>
          JoyJobs may collect sensitive personal information with a user's prior consent pursuant to the applicable
          states'statutes. You acknowledge and agree that all sensitive data collected by JoyJobs is with your consent,
          or as permitted or required under applicable laws.
        </li>
        <li>The right to non-discrimination.</li>
        <li>You have a right to not be discriminated against for exercising any of your rights.</li>
        <li>The right to an authorized agent.</li>
        <li>
          You have the right to designate another person to make a request on your behalf. We verify all requests
          through email before processing them and reserve the right to deny a request where we are unable to verify
          your identity satisfactorily. This also applies to requests submitted on your behalf by someone else.
        </li>
      </ul>
      <p>
        If you have been denied a request to exercise your rights as described in this section, you may appeal JoyJobs'
        decision by contacting hello@joylanders.com.
      </p>
      <a-divider class="content_divider" />
      <p class="sub_title">6. Regional Scope.</p>
      <p>
        JoyJobs currently only serves people in the United States. Should JoyJobs expands its services to different
        jurisdictions, this Privacy Policy may be amended in accordance with the applicable laws of such jurisdictions.
      </p>
      <a-divider class="content_divider" />
      <p class="sub_title">7. Data Security.</p>
      <p>
        JoyJobs uses reasonable security measures, including encryption for sensitive data, two-factor authentication
        for email-based accounts, role-based access controls for JoyJobs'staff, monitoring and auditing of internal
        access, and regular security updates and vulnerability testing, to help protect your Personal Data. JoyJobs
        intends to make your experience as secure as possible by protecting Personal Data covered by this policy against
        loss, misuse, alteration, or unauthorized access.However, no method of transmission or method of electronic
        storage of information via the Internet can be 100% secure. Where the security of your information is beyond our
        control, we cannot guarantee the privacy of such information.
      </p>
      <a-divider class="content_divider" />
      <p class="sub_title">8. Modification.</p>
      <p>
        JoyJobs may update these Terms from time to time. If JoyJobs makes any future material modification to these
        Terms, JoyJobs will notify you by email or showing a notification at the time you access the website. Your
        access to or use of the website following any such changes to the Terms will constitute your affirmative
        acceptance of such changes.
      </p>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();
const closePage = () => {
  // window.close() 只能关闭 window.open 打开的窗口，直接从首页进入时会被浏览器静默拦截
  // 优先返回上一页，没有历史记录则跳首页
  if (window.history.length > 1) {
    router.back();
  } else {
    router.push('/index');
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 850px;
  padding: 50px;
  margin: 50px auto;
  .back_btn {
    position: absolute;
    left: 20px;
    top: 10px;
  }
  .title {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #05644f;
    .logo {
      float: right;
      width: 230px;
      height: auto;
    }
  }
  .content {
    font-size: 14px;
    line-height: 24px;
    color: #3d3d3d;
    .date {
      font-size: 14px;
      color: #05644f;
      margin-bottom: 20px;
    }
    .sub_title {
      font-size: 24px;
      font-weight: 500;
      margin-top: 20px;
    }
    .content_divider {
      margin: 30px 0;
      background: #fff;
    }
    a {
      color: #0256ff;
      text-decoration: none;
    }
    .label {
      font-weight: 700;
    }
    .circle {
      display: inline-block;
      width: 5px;
      height: 5px;
      background-color: #3d3d3d;
      border-radius: 50%;
      margin-right: 8px;
      vertical-align: middle;
    }
    .content_ul {
      padding-left: 20px;
      li {
        margin-bottom: 10px;
      }
    }
    .content_table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 20px;
      td {
        min-width: 280px;
        border: 1px solid #3d3d3d;
        padding: 20px;
        vertical-align: top;
      }
    }
  }
  // 手机端适配（≤640px）：固定 850px 容器在手机上横向溢出，logo 与关闭按钮跑出屏幕
  @media (max-width: 640px) {
    position: relative;
    box-sizing: border-box;
    width: auto;
    padding: 56px 16px 32px;
    margin: 0 auto;
    .back_btn {
      position: absolute;
      left: 12px;
      top: 14px;
      img {
        width: 20px;
        height: 20px;
      }
    }
    .title {
      font-size: 20px;
      margin-bottom: 16px;
      .logo {
        width: 120px;
      }
    }
    .content {
      font-size: 13px;
      line-height: 21px;
      word-break: break-word;
      .date {
        margin-bottom: 14px;
      }
      .sub_title {
        font-size: 18px;
        margin-top: 16px;
      }
      .content_divider {
        margin: 20px 0;
      }
      .content_ul {
        padding-left: 18px;
      }
      // 两列表格：td 原有 min-width:280px 会撑破窄屏，改为自适应收窄
      .content_table {
        td {
          min-width: 0;
          padding: 10px;
          font-size: 12px;
          line-height: 19px;
          &:first-child {
            width: 104px;
          }
        }
      }
    }
  }
}
</style>
